export default __webpack_public_path__ + "static/media/Clients.c66e2185.png";